module.exports = __webpack_public_path__ + "static/img/9.5bf5162.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/9.png
// module id = x49A
// module chunks = 0